import React from 'react';

export default function TimelineLine({ ln, i }) {
  return (
    <div
      className={`flex justify-between gap-[10px] ${ln.bold ? 'text-[12.5px] font-bold text-navy mb-[5px]' : 'text-[11.5px] font-normal text-grey-dark mb-[2px]'}`}
    >
      <span className={`${ln.bold ? 'text-navy' : 'text-[#999]'}`}>{ln.label}</span>
      {ln.value && (
        <span
          className={`text-right ${ln.bold ? 'font-bold' : 'font-medium'}`}
          style={{ color: ln.color || '#333' }}
        >
          {ln.value}
        </span>
      )}
    </div>
  );
}
